import { ICON_MAP } from '../IconLibrary/iconLibraryMap';

export const ICON_AVATAR_MAP = {
  attended_appointment: { iconName: 'VideoCamera', iconColor: 'teal' },
  missed_appointment: { iconName: 'VideoCamera', iconColor: 'errorLight' },
  cancelled_appointment: { iconName: 'VideoCamera', iconColor: 'warningLight' },
  appointment: { iconName: 'VideoCamera', iconColor: 'blue' },
  change: { iconName: 'ArrowsClockwise', iconColor: 'teal' },
  consent: { iconName: 'SealCheck', iconColor: 'teal' },
  email: { iconName: 'Envelope', iconColor: 'blue' },
  error: { iconName: 'X', iconColor: 'error' },
  hospitalization: { iconName: 'Hospital', iconColor: 'blue' },
  incoming_call: { iconName: 'PhoneIncoming', iconColor: 'blue' },
  message: { iconName: 'ChatDots', iconColor: 'blue' },
  need: { iconName: 'HandHeart', iconColor: 'purple' },
  new_member: { iconName: 'UserPlus', iconColor: 'teal' },
  note: { iconName: 'Note', iconColor: 'purple' },
  notepad: { iconName: 'Notepad', iconColor: 'neutral' },
  outgoing_call: { iconName: 'Phone', iconColor: 'blue' },
  reminder: { iconName: 'BellRinging', iconColor: 'purple' },
  resource: { iconName: 'ListMagnifyingGlass', iconColor: 'purple' },
  scheduled_event: { iconName: 'BellRinging', iconColor: 'blue' },
  survey: { iconName: 'ClipboardText', iconColor: 'teal' },
  task: { iconName: 'CheckFat', iconColor: 'teal' },
  telehealth: { iconName: 'VideoCamera', iconColor: 'blue' },
  transfer: { iconName: 'ArrowsLeftRight', iconColor: 'teal' },
  user: { iconName: 'User', iconColor: 'teal' },
  user_square: { iconName: 'UserSquare', iconColor: 'teal' },
  visit: { iconName: 'HouseLine', iconColor: 'blue' },
  phone: { iconName: 'Phone', iconColor: 'neutral' },
  list_magnifying_glass: {
    iconName: 'ListMagnifyingGlass',
    iconColor: 'neutral',
  },
} as const satisfies Record<
  string,
  {
    iconName: keyof typeof ICON_MAP;
    iconColor: string;
  }
>;

export type IconAvatarType = keyof typeof ICON_AVATAR_MAP;
